import { search } from "@microsoft/teams-js";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";

const messages = {
    th: {
        UserQuery : "ข้อความค้นหาของผู้ใช้", 
        OrgVectorSearch: "ข้อมูลต้นฉบับสำหรับ Vector", 
        ModVectorSearch: "ข้อมูลปรับปรุงสำหรับ Vector (Eng.)", 
        Company : "บริษัท", 
        StreamFileNamePrivateMemory:"ชื่อ Document",
        StreamUploadPrivateMemory:"Upload",
        StreamPrivateMemory:"VECTOR",
        StreamPrivateMemoryAdd:"ADD",
        StreamPrivateMemoryEdit:"EDIT",
        StreamPopupFileHeader: "Upload File เสียง",
        StreamPopupVoiceHeader: "เสียงพูด",
        StreamPopuplang: "ภาษา",
        StreamPopupRecord: "Record",
        FullStream: "Full Stream",
        Stream: "แชท เพลย์กราวด์",
        no: "ลำดับที่",
        date: "วันที่",
        description: "ลักษณะ",
        usermanagement: "การจัดการผู้ใช้พอร์ทัล",
        userChatManagement: "การจัดการผู้ใช้แชท",
        user: "ผู้ใช้งาน",
        _CompanyCode: "รหัสบริษัท",
        username: "ชื่อผู้ใช้",
        email: "อีเมล",
        search: "ค้นหา",
        UploadImageEx: "ตัวอย่าง",
        IconPreview: "ดูตัวอย่างไอคอน",
        UploadImage: "รูป",
        add: "เพิ่ม",
        addProduct: "เพิ่มสินค้า",
        addIntentSession: "เพิ่มเซสชันความตั้งใจ",
        New: "ใหม่",
        manage: "จัดการ",
        phonenumber: "หมายเลขโทรศัพท์",
        employeename: "ชื่อพนักงาน",
        usertype: "ประเภทผู้ใช้",
        edit: "แก้ไข",
        delete: "ลบ",
        deleteAll: "ลบทั้งหมด",
        deleteSelected: "ลบที่เลือก",
        users: "ผู้ใช้",
        usergroup: "กลุ่มผู้ใช้",
        permissionmanagement: "การจัดการสิทธิ์",
        menumanagement: "การจัดการเมนู",
        managementModelQuick: "การจัดการ : Quick Model",
        managementGPTModel: "สร้างโมเดล",
        // managementGPTModelDetail: "การจัดการ : LLMs Model Detail",
        managementGPTModelNode: "การจัดการ : GPT Model Internal",
        managementModelAndVector: "การจัดการ Model & Vector DB",
        ValidationGenerateUpload: "Validation generate : Upload",
        calendar: "ปฎิทิน",
        log: "เข้าสู่ระบบ",
        setting: "การตั้งค่า",
        groupname: "ชื่อกลุ่ม",
        permissionname: "ชื่อสิทธิ์",
        save: "บันทึก",
        close: "ปิด",
        update: "ปรับปรุง",
        firstname: "ชื่อจริง",
        lastname: "นามสกุล",
        indicatesrequiredfield: "แสดงถึงฟิลด์ที่จำเป็น",
        userprofile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        password: "รหัสผ่าน",
        confirmpassword: "ยืนยันรหัสผ่าน",
        checklengthcharacters: "ความยาวอย่างน้อย 8 ตัวอักษร",
        checklowercaseletter: "อักษรตัวพิมพ์เล็กอย่างน้อย 1 ตัวอักษร",
        checkuppercaseletter: "อักษรตัวพิมพ์ใหญ่อย่างน้อย 1 ตัวอักษร",
        checknumber: "ตัวเลข(0-9)",
        checkspecialcharacter: "อักขระพิเศษอย่างน้อย 1 ตัว",
        checkpasswordmatch: "ยืนยันรหัสผ่านไม่ตรงกัน",
        rememberme: "จดจำฉัน",
        forgotpassword: "ลืมรหัสผ่าน?",
        login: "เข้าสู่ระบบ",
        successMessage: "เข้าสู่ระบบเรียบร้อยแล้ว",
        adduseringroup: "เพิ่มผู้ใช้ในกลุ่ม",
        menuname: "ชื่อเมนู",
        number: "จำนวน",
        addgroupinmenu: "เพิ่มกลุ่มในเมนู",
        addGPTModel: "เพิ่ม GPTModel",
        updateGPTModel: "แก้ไข GPTModel",
        addGPTModelNode: "เพิ่ม GPTModelNode",
        updateGPTModelNode: "แก้ไข GPTModelNode",
        uploadCSV: "อัปโหลดไฟล์ CSV",
        uploadNegativeQuestionSet: "อัปโหลดชุดคำถามเชิงลบ",
        upload: "อัปโหลด",
        downloadTemplate: "ดาวน์โหลดเทมเพลต",
        addModelAndVector: "เพิ่ม Model and Vector DB",
        type: "ประเภท",
        role: "บทบาท",
        setup_title: "การเชื่อมต่อแพลตฟอร์ม",
        general_title: "การตั้งค่าหลัก",
        chatLogs_title: "บันทึกแชท",
        setup_search_name: "ชื่อ",
        setup_table_no: "รหัส",
        setup_table_key: "ชื่อ",
        setup_table_value: "ข้อมูล",
        setup_btn_apply: "นำไปใช้",
        dashboard: "แดชบอร์ด",
        dashboardScore: "แดชบอร์ด คะแนน",
        question: "คำถาม",
        answer: "คำตอบ",
        score: "คะแนน",
        Validation: "Validation",
        GenerateTestQuestions_title: "สร้างคำถามทดสอบ",
        NegativeDataset_title: "ชุดคำถามเชิงลบ",
        ExecuteTestRuns_title: "ดำเนินการทดสอบ",
        DatabaseIntegration_title: "การเชื่อมต่อฐานข้อมูล",
        FileManagement_title: "การจัดการไฟล์",
        Documents_title: "เอกสาร",
        validationScore: "คะแนนการตรวจสอบ",
        calculateScores: "คำนวณคะแนน",
        averageScore: "ค่าเฉลี่ยคะแนน",
        totalUser: "ผู้ใช้ทั้งหมด",
        month: "เดือน",
        LastDayTotalUserUsage: "การใช้งานผู้ใช้รวมในวันที่ผ่านมา",
        UpdatedIn: "ภายในเมื่อวาน",
        UsageOverview: "ภาพรวมการใช้งาน",
        TokensUsedMonth: "จำนวนการใช้ Tokens",
        Usage: "การใช้งาน",
        TokensUsed: "Tokens ใช้ไปทั้งหมด",
        TotalTokenIn: "โทเค็นทั้งหมดเข้า",
        TotalTokenOut: "โทเค็นทั้งหมดออก",
        TotalPriceForTokenIn: "ราคารวมสำหรับโทเค็นใน",
        TotalPriceForTokenOut: "ราคารวมสำหรับโทเค็นออก",
        TokensUsedTokensChat: "จำนวน Tokens ทั้งหมดที่ใช้ในการแชท",
        DetailTokensUsedTokensChat: "จำนวน Tokens ทั้งหมดที่ใช้ในการแชท",
        DetailImageGenChat: "จำนวนการสร้างภาพทั้งหมดที่ใช้ในการแชท",
        ImageGenTotalInChat: "จำนวนการสร้างภาพทั้งหมดที่ใช้ในการแชท",
        ImageGenTotal: "จำนวนการสร้างภาพทั้งหมด",
        TotalGeneratedImage: "รูปภาพที่สร้างขึ้นทั้งหมด",
        ImageGenTotalPrice: "ราคาการสร้างภาพทั้งหมด",
        TotalGeneratedImagePrice: "ราคาภาพที่สร้างทั้งหมด",
        ImageGenTotalPriceInChat: "ราคาการสร้างภาพทั้งหมดที่ใช้ในการแชท",
        DallE3GeneratedImagesPriceInChat: "ราคา Dall-E 3 Generated Images ในแชท",
        GeneratedImagesPriceInChat: "ราคาภาพที่สร้างขึ้นในแชท",
        TokensUsedPromptTokensChat: "จำนวน Tokens พร้อมท์ทั้งหมดที่ใช้ในการแชท",
        GPT4oPromptTokens: "โทเค็นพร้อมท์ GPT-4o",
        ChatPromptTokens: "โทเค็นพร้อมท์แชท",
        TokensUsedCompletionTokensChat: "จำนวน Tokens การเสร็จสิ้นทั้งหมดที่ใช้ในการแชท",
        GPT4oUsageTokens: "โทเค็นการใช้งานเสร็จสมบูรณ์ GPT-4o",
        ChatCompletionTokens: "โทเค็นการเสร็จสิ้นการแชท",
        TokensUsedEmbedding: "จำนวน Tokens ทั้งหมดในการ Embedding",
        NumberUsers: "ผู้ใช้ทั้งหมด",
        TotalModels: "จำนวน Models ทั้งหมด",
        WithinThisMonth: "ภายในเดือนนี้",
        UserUsage: "การใช้งานของผู้ใช้",
        WithinThis30daysagoToTotalUsers: "ผู้ใช้ย้อนหลังภายใน 30 วัน/ผู้ใช้ทั้งหมด",
        UserWithinThisDay: "ผู้ใช้ภายใน",
        DaysToTotalUsers: "วัน/ผู้ใช้ทั้งหมด",
        TotalUsagePerMonth: "การใช้งานรวมต่อเดือน",
        NumberPeople: "จำนวนคน",
        NumberData: "จำนวนข้อมูล",
        People: "คน",
        NumberQuestions: "จำนวนคำถาม",
        gpt_model_management_replace: "แทนที่",
        gpt_model_management_version_history: "ประวัติเวอร์ชัน",
        gpt_model_management_version_history_detail: "รายละเอียดประวัติเวอร์ชัน",
        gpt_model_management_export_file_config: "ส่งออกไฟล์",
        importVectorTitle: "คุณต้องการนำเข้า Vector หรือไม่ ",
        importPrivate_MemoryTitle: "คุณต้องการนำเข้า Vector หรือไม่ ",
        doctype : "ประเภทเอกสาร",
        vectortype : "ประเภทโครงสร้าง",
        process_type: "ประเภทกระบวนการ",
        yes: 'ใช่',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        confirmDeletion: 'ยืนยันการลบ',
        confirmDeletion2: 'คุณต้องการยืนยันการลบนี้หรือไม่',
        confirmDeletionGroup: 'คุณต้องการยืนยันการลบกลุ่มนี้หรือไม่',
        // confirmDeletionModel: 'คุณต้องการยืนยันการลบโมเดลนี้หรือไม่',
        confirmDeletionModelPart1: 'คุณต้องการยืนยันการลบโมเดล', // Added part 1
        confirmDeletionModelPart2: 'หรือไม่', // Added part 2
        confirmDeletionMessage: 'คุณต้องการยืนยันการลบข้อความนี้หรือไม่',
        confirmDeletionModelGroup: 'คุณต้องการยืนยันการลบกลุ่มโมเดลนี้หรือไม่',
        confirmDeletionModelShortcut: 'คุณต้องการยืนยันการลบ model shortcut นี้หรือไม่',
        confirmDeletionSetting: 'คุณต้องการยืนยันการลบการตั้งค่านี้หรือไม่',
        confirmDeletionVectorName: 'คุณต้องการยืนยันการลบเวกเตอร์เนมนี้หรือไม่',
        confirmDeletionDocumentName: 'คุณต้องการยืนยันการลบชื่อเอกสารนี้หรือไม่',
        confirmDeletionDocument: 'คุณต้องการยืนยันการลบเอกสารนี้หรือไม่',
        confirmDeletionTableName: 'คุณต้องการยืนยันการลบ table name นี้หรือไม่',
        confirmDeletionIntentGroup: 'คุณต้องการยืนยันการลบ intent group นี้หรือไม่',
        confirmDeletionIntentSession: 'คุณต้องการยืนยันการลบ intent session นี้หรือไม่',
        confirmDeletionVector: 'คุณต้องการยืนยันการลบเวกเตอร์นี้หรือไม่',
        confirmDeletionUser: 'คุณต้องการยืนยันการลบผู้ใช้งานนี้หรือไม่',
        confirmDeletionFile: 'คุณต้องการยืนยันการลบไฟล์นี้หรือไม่',
        confirmDeletionAllFile: 'คุณต้องการยืนยันการลบไฟล์ทั้งหมดนี้หรือไม่',
        confirmDeletionQuestion: 'คุณต้องการยืนยันการลบคำถามนี้หรือไม่',
        confirmDeletionAllQuestion: 'คุณต้องการยืนยันการลบคำถามทั้งหมดนี้หรือไม่',
        confirmDeletionPrompt: 'คุณต้องการยืนยันการลบพรอมต์นี้หรือไม่',
        confirmOn: 'ยืนยันการเปิด',
        confirmOff: 'ยืนยันการปิด',
        confirmOnVectorName: 'คุณต้องการยืนยันการเปิดเวกเตอร์นี้หรือไม่',
        confirmOffVectorName: 'คุณต้องการยืนยันการปิดเวกเตอร์นี้หรือไม่',
        confirmDeleteConfirmation: 'ยืนยันการลบ',
        vectorReprocess: "คุณต้องการประมวลผลใหม่",
        conditionScore0: '0 = คำตอบจาก GPT ไม่เกี่ยวข้องกับคำถาม',
        conditionScore1: '1 = คำตอบจาก GPT เกี่ยวข้องกับคำถามประมาณ 50% - 80%',
        conditionScore2: '2 = คำตอบจาก GPT มีความเกี่ยวข้องกับคำถามมากที่สุด หรือคำตอบที่ GPT ไม่สามารถตอบได้',
        general: 'พื้นฐาน',
        social: 'โซเชียล',
        QuickModel: 'โมเดลชอร์ตคัท',
        groupModel: 'การจัดกลุ่มโมเดล',
        groupModelName: 'ชื่อกลุ่มโมเดล',
        groupIntentName: 'ชื่อกลุ่ม Intent',
        modelQuickGroupName: 'ชื่อกลุ่ม Quick Model',
        modelID: 'โมเดลไอดี',
        model: 'โมเดล',
        modelName: 'ชื่อโมเดล',
        modeldata: 'การจัดการ LLMs',
        editnewmodel: 'แก้ไขโมเดลใหม่',
        deletemodeldata: 'ลบข้อมูลโมเดล',
        areyousuretodeletethisdata: 'คุณแน่ใจที่จะลบข้อมูลนี้หรือไม่?',
        addnewmodel: 'เพิ่มโมเดลใหม่',
        loadingpleasewait: 'กำลังโหลด กรุณารอสักครู่...',
        pleasefillininformation: 'กรุณากรอกข้อมูล',
        superAdmin: 'ผู้ดูแลระบบขั้นสูง',
        oneSuperAdmin: 'ต้องมีบทบาทผู้ดูแลระบบขั้นสูง อย่างน้อย 1 คน',
        notAuthoritySuperAdmin: 'คุณไม่มีสิทธิ์ลบบทบาทผู้ดูแลระบบขั้นสูง',
        admin: 'ผู้ดูแลระบบ',
        generalUsers: 'ผู้ใช้งานทั่วไป',
        totalNumber: 'จำนวนทั้งหมด',
        groupReplaceText: 'การแทนที่ข้อความ',
        replaceText: 'แทนที่ข้อความ',
        specificText: 'ข้อความจำเพาะ',
        importReplaceTextTitle: "คุณต้องการนำเข้า Replace Text หรือไม่ ?",
        importIntentText: "คุณต้องการนำเข้า Intent Text หรือไม่ ?",
        warning: 'แจ้งเตือน',
        warningSpecialCharacters: 'ตรวจพบมีตัวอักขระพิเศษ! กรุณาลบทิ้ง',
        warningFillAll: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        warningFillIntentGroupName: 'กรุณากรอก Intent Group Name',
        warningModelName: 'กรุณากรอก Model name',
        warningProvider: 'กรุณาเลือก Provider',
        warningModel: 'กรุณาเลือก Model',
        warningPublish: 'กรุณาเลือก Draft หรือ Publish',
        warningTemperature: 'กรุณากรอก Temperature ตั้งแต่ค่า 0 - 1 (ทศนิยม 2 แหน่ง)',
        warningChainMassage: 'กรุณาใส่ลำดับหรือระยะเวลาเพื่อเปิดใช้งานการ Multi-Turn Input',
        warningTopP: 'กรุณากรอก topP ตั้งแต่ค่า 0 - 1 (ทศนิยม 2 แหน่ง)',
        warningVectordbName: 'กรุณาเลือก Vector DB name (เลือกได้มากกว่า 1)',
        warningTopVDB: 'กรุณากรอก Top VDB ตั้งค่า 1 เป็นต้นไป',
        warningAPIVersion: 'กรุณาเพิ่ม API Version ใน Master Data',
        warningWaitProcess: 'กรุณารอให้ process ก่อนหน้านี้ทำงานเสร็จก่อน',
        warningFillCustomMaxCharacter: 'กรุณากรอก Custom Max Character',
        warnningStartdateEnddate: 'กรุณากรอก StartDate และ EndDate',
        warningDuplicateDomain: 'ตรวจพบมีการใช้ Domain นี้แล้ว',
        warningEnableTime: 'กรุณาระบุ Time Zone หากเปิดใช้งานเวลา กรุณาเลือกเขตเวลาเพื่อให้บอทเข้าใจเวลาปัจจุบัน',
        warningEmailConfig: 'โปรดกรอกข้อมูลอีเมลทั้งหมดให้ครบถ้วน',
        
        errorUploadImage: 'ไม่สามารถอัพโหลดรูปภาพได้ กรุณาลองใหม่อีกครั้ง',
        totalUsedChatExpense: "ค่าใช้จ่ายทั้งหมดที่ใช้ในการแชท", 
        totalExpense: "ราคารวมทั้งหมด",
        totalPriceForEmbedding: "ราคาทั้งหมดในการ Embedding",
        priceForAllChatUsage: "ราคาทั้งหมดสำหรับการใช้งานแชท",
        totalPriceOfPromptChat: "ราคาทั้งหมดสำหรับการใช้งาน Prompt",
        totalPriceOfCompletionChat: "ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น",
        totalPriceOfUsageChat: "ราคารวมการใช้งานแชท",
        totalPriceOfPromptGPT3: "ราคาทั้งหมดสำหรับการใช้งาน Prompt GPT-3-Turbo",
        totalPriceOfPromptGPT316k: "ราคาทั้งหมดสำหรับการใช้งาน Prompt GPT-3-Turbo-16k",
        totalPriceOfPromptGPT4: "ราคาทั้งหมดสำหรับการใช้งาน Prompt GPT-4",
        totalPriceOfPromptGPTOTHER: "ราคาทั้งหมดสำหรับการใช้งาน Prompt Other",
        totalPriceOfCompletionChatGPT3: "ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น GPT-3-Turbo",
        totalPriceOfCompletionChatGPT316k: "ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น GPT-3-Turbo-16k",
        totalPriceOfCompletionChatGPT4: "ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น GPT-4",
        totalPriceOfCompletionChatGPTOTHER: "ราคาทั้งหมดสำหรับการใช้งาน การเสร็จสิ้น อื่นๆ",
        baht: "บาท",        
        TokensUsedPromptGPT3TokensChat: "จำนวน Tokens Prompt GPT-3-Turbo ทั้งหมดที่ใช้ในการแชท",
        TokensUsedPromptGPT316kTokensChat: "จำนวน Tokens Prompt GPT-3-Turbo-16k ทั้งหมดที่ใช้ในการแชท",
        TokensUsedPromptGPT4TokensChat: "จำนวน Tokens Prompt GPT-4 ทั้งหมดที่ใช้ในการแชท",
        TokensUsedCompletionGPT3TokensChat: "จำนวน Tokens การเสร็จสิ้น GPT-3-Turbo ทั้งหมดที่ใช้ในการแชท",
        TokensUsedCompletionGPT316kTokensChat: "จำนวน Tokens การเสร็จสิ้น GPT-3-Turbo-16k ทั้งหมดที่ใช้ในการแชท",
        TokensUsedCompletionGPT4TokensChat: "จำนวน Tokens การเสร็จสิ้น GPT-4 ทั้งหมดที่ใช้ในการแชท",
        promptPrice:"ราคา Prompt",
        completionPrice:"ราคา Completion",
        T30dayago: "ย้อนหลังภายใน 30 วัน",
        WithinThis30daysago: "ย้อนหลังภายใน 30 วัน",
        WithinThisDaysAgo: "ภายใน",
        LastDays: "ล่าสุด",
        Day: "วัน",
        ReportQuestion: "แนวโน้มคำถาม",
        ReportUser: "ผู้ใช้งานยอดนิยม",
        ReportFeedback: "Report Feedback",
        Questions: "คำถาม",
        Answers: "คำตอบ",
        LikeDislike: "ชอบ/ไม่ชอบ",
        Comments: "ความคิดเห็น",
        PromptTemplate: "Prompt Template",
        Active: "ใช้งาน",
        Inactive: "ไม่ใช้งาน",
        ReportTotalQuestionByUser: "ข้อมูลการใช้งานทั้งหมด",
        SettingExternalConnector: "การเชื่อมต่อภายนอก",
        ModelDisplay: "ชื่อโมเดลที่แสดง",
        Provider: "ผู้ให้บริการ",
        releases: "Release notes",
        vector_management_duplicate: "ทำซ้ำ",
        vector_management_replace: "แทนที่",
        vector_duplicate : "Duplicate Document",

        importUserTitle: "คุณต้องการนำเข้า User หรือไม่ ",
        system: "ระบบ",
        internal: "ภายใน",
        external: "ภายนอก",
        testConnection: "ทดสอบการเชื่อมต่อ",
        allcolumn: "ดึงทุกคอลัมน์",
        connectionString: "สตริงการเชื่อมต่อ",
        view: "ดู",
        view_detail: "ดูรายละเอียด",
        dataIntegrationName: "ชื่อการรวมข้อมูล",
        SocialUserID: "Line User ID",
        RecipientId: "Facebook User ID",
        RecipientId_Instagram: "Instagram User ID",
        ConfirmDataAddition: "ยีนยันการเพิ่มข้อมูล",
        TranslateEnglish: "แปลภาษาอังกฤษ",
        DataSearchVector: "ข้อมูลค้นหา Vector",
        selectToDeleteFile: "เลือกลบไฟล์",

        _InfoModelDisplay: "ข้อมูล Model Display จะแสดงเลข Model Display เมื่อมีการเผยแพร่หรือบันทึกเป็นร่าง",
        _InfoModelName: "ชื่อ Model",
        _InfoProvider: "เลือกผู้ให้บริการ",
        _InfoModel: "Model จากผู้ให้บริการ",
        _InfoExtension: "ส่วนขยายของ Model",
        _InfoDescriptiion: "คำอธิบายเพิ่มเติม",
        _InfoGender: "เพศของ Chatbot",
        _InfoVersion: "Version ที่ใช้งานอยู่ในปัจจุบัน",
        _InfoStream: "กรณีเลือก Stream จะเป็นการที่ Chat Frame Work จะแสดงการตอบแบบที่ละตัวอักษร",
        _InfoByPass: "กรณีเลือก Bypass จะเป็นการที่เปิดให้ Chat Frame Work สามารถตอบข้อมูลนอกจากภายใน Prompt หรือ Vector ที่มีข้อมูลที่กำหนดไว้ สามารถหาข้อมูลเองจาก public knowledge เพื่อเอามาตอบ",
        _InfoFeedback: "กรณีเลือก Feedback จะเป็นการที่เปิดให้ Chat Frame Work ใช้งานการรับความคิดเห็นของผู้ใช้ได้",
        _InfoEnableTime: "กรณีเลือก เปิดใช้งานเวลาใน Prompt ระบบจะเพิ่มวันและเวลาปัจจุบันเข้าไปในการสนทนา ทำให้บอทสามารถรับรู้และตอบสนองตามเวลาจริงได้",
        _InfoImageUpload: "กรณีเลือก Upload image จะเป็นการที่เปิดให้ Chat Frame Work ใช้งานการอัพโหลดรูปภาพเพิื่อใช้ในการถาม",
        _InfoVectorDBName: "Vector ที่สร้างไว้ สามารถแก้ไขได้ในหน้าเอกสาร",
        _InfoGroupReplaceText: "กลุ่มคำที่ได้แก้ไขไว้ สามารถแก้ไขได้ในหน้าการแทนที่ข้อความ",
        _InfoTopVDB: "จำนวนค่าความน่าจะเป็นที่มากที่สูง",
        _InfoCosine: "ค่าความน่าจะเป็น",
        _InfoSequence: "จำนวนลำดับของบทสนทนาที่จะนำมารวมกันเพื่อใช้ในการค้นหาและตอบคำถามครั้งล่าสุด",
        _InfoTimeSeconds: "เชื่อมโยงคำถามที่อยู่ในช่วงเวลาที่กำหนด(วินาที)",
        _InfoMemory: "เปิดใช้งาน Sequence, Time",
        _InfoMultiTurnInput: "เปิดใช้งาน Multi-Turn Input",
        _InfoTurn: "จำนวนรอบทีสามารถจำข้อมูลได้",
        _InfoMinute: "เวลาที่สามารถจำข้อมูลได",
        _InfoShortMemory: "จำนวนตัวอักษร สำหรับจำข้อมูล",
        _InfoLongtermMemory: "เก็บข้อมูลแบบระยะยาว (เก็บข้อมูลรูปแบบของ Chunk)",
        _InfoTemperature: "ควบคุมความสุ่ม การลดอุณหภูมิหมายความว่าโมเดลจะสร้างคำตอบที่ซ้ำซ้อนและมีการกำหนดมากขึ้น การเพิ่มอุณหภูมิจะทำให้ได้คำตอบที่ไม่คาดคิดหรือสร้างสรรค์มากขึ้น ลองปรับอุณหภูมิหรือ Top P แต่ไม่ทั้งสองอย่าง",
        _InfoTopP: "คล้ายกับอุณหภูมิ สิ่งนี้ควบคุมความสุ่มแต่ใช้วิธีที่แตกต่าง การลด Top P จะทำให้การเลือกโทเค็นของโมเดลแคบลงไปยังโทเค็นที่มีความน่าจะเป็นมาก การเพิ่ม Top P จะทำให้โมเดลสามารถเลือกจากโทเค็นที่มีความน่าจะเป็นสูงและต่ำ ลองปรับอุณหภูมิหรือ Top P แต่ไม่ทั้งสองอย่าง",
        _InfoFrequencyPenalty: "ลดโอกาสในการทำซ้ำโทเค็นโดยอิงจากความถี่ที่มันปรากฏในข้อความจนถึงตอนนี้ สิ่งนี้จะลดความน่าจะเป็นในการทำซ้ำข้อความเดียวกันในการตอบสนอง.",
        _InfoPresencePenalty: "ลดโอกาสในการทำซ้ำโทเค็นใด ๆ ที่ปรากฏในข้อความจนถึงตอนนี้ สิ่งนี้จะเพิ่มความน่าจะเป็นในการนำเสนอหัวข้อใหม่ในการตอบสนอง.",
        _InfoMaxToken: "จำนวน Tokens สูงสุด",
        _InfoStop: "ทำให้โมเดลสิ้นสุดการตอบสนองของมันที่จุดที่ต้องการ การตอบสนองของโมเดลจะสิ้นสุดก่อนลำดับที่ระบุ ดังนั้นจะไม่มีข้อความของลำดับหยุดอยู่ในนั้น สำหรับ ChatGPT, การใช้ <|im_end|> จะทำให้แน่ใจว่าการตอบสนองของโมเดลจะไม่สร้างคำถามตามจากผู้ใช้ คุณสามารถรวมลำดับหยุดได้มากถึงสี่ลำดับ.",
        _InfoDataIntegration: "ข้อมูลจาก Data Integration",
        _InfoSQLExtractStatement: "model ที่ใช้สำหรับสร้าง SQL Statement",
        _InfoPromt: "ให้คำแนะนำในการสร้างโมเดลเกี่ยวกับวิธีการทำงานและบริบทที่ควรอ้างอิงเมื่อสร้างคำตอบ คุณสามารถบรรยายลักษณะของผู้ช่วย บอกว่าควรและไม่ควรตอบอะไร และบอกวิธีการจัดรูปแบบคำตอบ ไม่มีขีดจำกัดสำหรับส่วนนี้ แต่จะรวมอยู่ในทุกการเรียก API ดังนั้นจึงนับเป็นส่วนหนึ่งของขีดจำกัดโทเค็นโดยรวม",
        _InfoAdditionalPromt: "สามารถเลือกพร็อมต์เทมเพลสแทนที่พร็อมต์",
        _InfoVectorDatabaseName: "ชื่อ Vector",
        _InfoProcess_type: "เลือกประเภทการดำเนินการ",
        _InfoCustomMaxCharacter: "จำนวนตัวอักษรสูงสุด",
        _InfoDetectLanguage: "ตรวจสอบภาษา",
        _InfoDoctype: "ประเภทเอกสารที่ต้องการ UPLOAD",
        _InfoVectortype: "ประเภทโครงสร้างของเอกสารที่อัพโหลด ตรวจสอบประเภทของเอกสารได้ที่ Template",
        _InfofillterModelType: "ประเภทของการแบ่งข้อมูล",
        _InfoDataIntegrationName: "ชื่อ Data integration",
        _InfoConnectionString: "เชื่อมต่อ Connection string ของ SQL Server",
        _InfoSchema: "ชื่อ Schema",
        _InfoTable: "ชื่อ Table",
        _InfoFuzzy: "เปรียบเทียบข้อมูลที่มีใน Table เพื่อใช้ในการแก้ไขคำผิด",
        _InfoFuzzyWithBot: "FuzzyWithBot : เปรียบเทียบข้อมูลที่มีใน Table เพื่อใช้ในการแก้ไขคำผิดโดยใช้ Bot เป็นตัวช่วย",
        _Personal_Info: "ข้อมูล Column ส่วนนี้จะถูกตรวจสอบการเข้าถึงของผู้ใช้",
        _InfoAllCloumns: "ดึงทุกคอลัมน์ใน Table",
        _InfoAddColumn: "เพิ่มเฉพาะ Column ที่ต้องการ(ไม่จำเป็นต้องใช้ทุก Column ที่มีอยู่ใน Table)",
        _InfoReplaceGroup: "กรุณากรอกชื่อกลุ่ม",
        _InfoNumberOfQuestions: "จำนวนคำถาม ที่จะนำไป Generate",
        _InfoNumberOfQuestionsTone: "กำหนดจำนวนที่จะสร้างคำถามของแต่ละ Tone",
        _InfoTypeOptions: "Token usage = สำหรับตรวจสอบจำนวน Token ที่ใช้ไป, Raw log = Log ทั้งหมด, Memory Debugger = ข้อมูล memory ที่ถูกจัดเก็บในการถามตอบแต่ละครั้ง",
        _InfoStartDate: "วันที่เริ่มต้น",
        _InfoEndDate: "วันที่สิ้นสุด",
        _InfoValidationNegariveName: "ชื่อของ Validation Negative",
        _InfoValidationName: "ชื่อ Validation",
        _InfoQuestionPositiveName: "ชื่อของคำถาม Positive name",
        _InfoQuestionNegativeName: "ชื่อของคำถาม Negative name",
        _InfoSelectModel: "เลือก Model",

        _InfoBoxFirm: "Firm",
        _InfoBoxConfident: "Confident",
        _InfoBoxPoetic: "Poetic",
        _InfoBoxNarrative: "Narrative",
        _InfoBoxProfessional: "Professional",
        _InfoBoxDescriptive: "Descriptive",
        _InfoBoxHumorous: "Humorous",
        _InfoBoxAcademic: "Academic",
        _InfoBoxPersausive: "Persausive",
        _InfoBoxFormat: "Format",
        _InfoBoxInformal: "Informal",
        _InfoBoxFriendly: "Friendly",

        _InfoSelectGroupModel: "เลือก Group model หากต้องการแก้ไข Model ที่อยู่ภายในกลุ่มสามารถแก้ไขได้ที่หน้า Group model",
        _InfoSelectQuickModel: "เลือก Quick model หากต้องการแก้ไข Model ที่อยู่ภายในกลุ่มสามารถแก้ไขได้ที่หน้า Quick model",
        _InfoCurrentPrompPrice: "ราคาสำหรับการถามคำถามต่อ 1,000 token",
        _InfoCurrentComppletionPrice: "ราคาสำหรับการตอบคำถามต่อ 1,000 token",
        _InfoVersionOfModel: "Version ของ model",
        _InfoPromptTemplateName: "ชื่อ Prompt template",
        _InfoStatusTemplate: "สถานะการใช้งาน Template คุณสามารถเปิดใช้งาน Template ได้สูงสุด 10 Template",
        _InfoPriority: "ลำดับความสำคัญ",
        _InfoGroupModelName: "ชื่อ Model ที่ถูกจัดเป็นกลุ่ม",
        _InfoAllModel: "เลือก model ทั้งหมด",
        _InfoModelinGroup: "Model ที่ถูกเลือกจะถูกจัดอยู่ในกลุ่มเดียวกัน",
        _InfoTimeDelay: "ระยะการหน่วงเวลา(มิลลิวินาที)",
        _InfoLimitedCharacter: "การจำกัดตัวอักษร",
        _InfoHostName: "Host name",
        _InfoEmailHost: "Email host",
        _InfoSetupLinkMS: "Link สำหรับใช้งานบน MS Teams (iFrame)",
        _InfoModelQuickGroupName: "Model ที่อยู่ภายใต้ Group model",
        _InfoGroupName: "ชื่อกลุ่ม Model",
        _InfoGroupPromptTemplate: "เลือก Group Prompt template",
        _InfoMSTeamsName: "ชื่อที่ไว้ใช้สำหรับ MS Teams",
        _InfoMonitorLINEUserid: "UserID ของ line ที่ไว้ใช้สำหรับ Monitor",
        _InfoLINEName: "ชื่อ Line",
        _InfoTypingSpeed: "กำหนดความเร็วในการตอบคำถาม (มิลลิวินาที)",
        _InfoMaximumChatInput: "กำหนดข้อความในการพิม์สูงสุด",
        _InfoDomainNameForSnippet: "ชื่อ Domain สำหรับใช้งานใน Snippet.",
        _InfoFacebookName: "ชื่อ สำหรับใช้งานใน Facebook.",
        _InfoAPI_Version: "API Version สำหรับใช้งานใน Facebook Messenger API.",
        _InfoPageId: "Page ID สำหรับใช้งานใน Facebook Page.",
        _InfoMaximumFileUpload: "กำหนดขีดจำกัดอัพโหลดไฟล์ (KB)",
        _UseUploadFile: "ใช้การอัพโหลดไฟล์",
        _InfoScore: "Score คือระดับการให้ความสำคัญ เรียงลำดับจากน้อยไปมากยกตัวอย่าง ถ้าเจอ intent ที่ตรงกัน มากกว่า 1 ตัว จะเลือก Intent จากค่า score ที่น้อยที่สุด",
        _InfoForUploadDateTimeDataType: "ถ้าเลือกประเภทข้อมูลเป็น วันที่และเวลา ให้ใส่ในรูปแบบ ปี/เดือน/วัน ชั่วโมง:นาที:วินาที เท่านั้น เช่น 2024/12/31 12:30:00",
        _InfoForDeleteAllFile: "ลบไฟล์ทั้งหมด",
        _InfoInstagramName: "ชื่อ สำหรับใช้งานใน Instagram.",

        _InfoNotiOn: "เปิดเสียงแจ้งเตือนแล้ว",
        _InfoNotiOff: "ปิดเสียงแจ้งเตือนแล้ว",

        loginMicrosoft: "เข้าสู่ระบบด้วย Microsoft",
        sync: "Sync",
        _SSOWarning: "Single Sign-On ยังไม่ได้เปิดใช้งาน กรุณาไปเปิดใช้งานที่เมนู Setup",
        PlayGround: "แชท เพลย์กราวด์คู่",
        _columnDataIntegration : "คอลัมน์",
        _typeDataIntegration : "ชนิดข้อมูล",
        _duplicateColumn : "หัว column มีการซ้ำกัน",
        _incorrectColumn : "หัว column ไม่ถูกต้อง",
        _ConfirmDataUpdate: "ยีนยันการแก้ไขข้อมูล",

        _ShowAllText : "แสดงข้อความทั้งหมด",
        _ShowAllTextOn : "เปิด",
        _ShowAllTextOff : "ปิด",
        _ShowPromptTemplate: "แสดง Prompt Template",
        _ShowAll: "แสดงทั้งหมด",

        //Navbar Name
        _Dashboard : "แดชบอร์ด",
        _ModelCreator : "สร้างโมเดล",
        _KnowledgeManagement : "การจัดการความรู้",
        _Documents : "เอกสาร",
        _DocumentList : "Document List",
        _DatabaseIntegration : "การเชื่อมต่อฐานข้อมูล",
        _OptimizationTechniques : "เทคนิคการเพิ่มประสิทธิภาพ",
        _TextReplacement : "การแทนที่ข้อความ",
        _ModelTesting : "การทดสอบโมเดล",
        _GenerateTestQuestions : "สร้างคำถามทดสอบ",
        _NegativeQuestionSet: "ชุดคำถามเชิงลบ",
        _UploadNegativeQuestionSet: "อัปโหลดชุดคำถามเชิงลบ",
        _EditNegativeQuestionSet: "แก้ไขชุดคำถามเชิงลบ",
        _ExecuteTestRuns : "ดำเนินการทดสอบ", 
        _UserManagement : "การจัดการผู้ใช้",
        _PortalUserManagement : "ผู้ใช้พอร์ทัล",
        _ChatUserManagement : "การจัดการผู้ใช้แชท",
        _ChatUser: "ผู้ใช้แชท",
        _ChatManagement : "การจัดการแชท",
        _Setting : "การตั้งค่า", 
        _CoreConfigurations : "การตั้งค่าหลัก",
        _PlatformIntegration : "การเชื่อมต่อแพลตฟอร์ม",
        _ModelGrouping : "การจัดกลุ่มโมเดล", 
        _ExternalConnector : "การเชื่อมต่อภายนอก",
        _ModelShortcut : "โมเดลชอร์ตคัท",
        _LLMsManagement : "การจัดการ LLMs", 
        _PromptTemplate: "Prompt Template Group List ",
        _Reports : "รายงาน",
        _QuestionTrends : "แนวโน้มคำถาม", 
        _TopUsers : "ผู้ใช้งานยอดนิยม", 
        _TotalUsageInsights : "ข้อมูลการใช้งานทั้งหมด", 
        _ChatLogs : "บันทึกแชท", 
        _ChatPlayground : "แชท เพลย์กราวด์",
        _DualChatPlayground : "แชท เพลย์กราวด์คู่",
        _ChatService : "บริการแชท",
        _DocumentManagement: "การจัดการเอกสาร",
        _Product: "ผลิตภัณฑ์",
        _ProductDetail: "รายละเอียดผลิตภัณฑ์",

        _EnableTime: "ใช้วันและเวลาใน Prompt",
        serviceTheme: "ตั้งค่าธีม",
        consentConfig: "การกำหนดความยินยอม",
        IntentGroup: "Intent Group",
        IntentSession: "Intent Session",
        TokenSummation: "Token summation",
        Intent: "Intent",
        _uploadCSVVector: "อัปโหลดไฟล์ CSV vector",
        configTheme: "ตั้งค่าธีม",
        loginAuthentik: "เข้าสู่ระบบด้วย Authentik",
        _GroupUserManagement: "Group User Management",
        _UserGroupManagement: "User Group Management",
        _UserGroup: "กลุ่มผู้ใช้",
        addUserGroup: "เพิ่มกลุ่มผู้ใช้",
        groupPromptName: "ชื่อกลุ่ม Prompt Template",
        modelGroup: "Model Group",
        _UserGroupDetail: "User Group Detail",
        _SetupUserGroup: "Setup User Group",
        action: "Action",
        groupObjectID: "Group ObjectID",
        fullName: "ชื่อ-นามสุกล",
        loginLine: "เข้าสู่ระบบด้วย Line",
        statusSync: "Status Sync",
        _BlacklistChatUserManagement: "การจัดการผู้ใช้แชท Blacklist ",
        _BlacklistChatUser: "ผู้ใช้แชทบัญชีดำ",
        _username: "ชื่อผู้ใช้",
        _userid: "User ID",
        _date: "วันที่",
        _FileManagement: "การจัดการไฟล์",
        confirmToSetDefault: "ยืนยันตั้งค่าเริ่มต้น",
        infoconfirmToSetDefault: "คุณต้องการยืนยันการตั้งค่าธีมเริ่มต้นหรือไม่?",
        headerLogo: "Header Logo",
        background: "Background",
        _LockStatus: "สถานะการล็อค",
        _Locked: "ล็อค",
        _Unlocked: "ปลดล็อค",
        _Connection_failed: "การเชื่อมต่อล้มเหลว โปรดตรวจสอบอินเทอร์เน็ตของคุณ",
        _Please_check_internet: "โปรดตรวจสอบอินเทอร์เน็ตของคุณ",
        _Operator: "ผู้ดำเนินการ",
        _Please_Question: "กรุณาระบุคำถาม",
        _HumanAnswer: "คำตอบของมนุษย์",
        _Reprocess: "คุณต้องการประมวลผลใหม่",
        "Upload Sound To Document": "Upload Sound To Document",
        "Positive Question set": "Positive Question set",
        "Model Quick Reply": "Model Quick Reply",
        Logs: "การบันทึก",
        "Report Feedback": "Report Feedback",
        ShortcutCommands: "Shortcut Commands",
        shortcutMenu: "Shortcut Menu",
        usermanual: "คู่มือผู้ใช้",
        releasesnotes: "บันทึกเวอร์ชัน",
        alreadyPublishedModel: "Model นี้เผยแพร่อยู่แล้ว",
        gotIt: "เข้าใจแล้ว",
        "Event Log": "Event Log",
        _ReasoningEffort: "ใช้การกำหนดระดับความพยายามในการใช้เหตุผล",
        _EndPointURL: "End Point URL",
        _WarningJSONFormat: "กรอกข้อมูลในรูปแบบ JSON",
        _API_Key: "API Key",
        warningReasoningEffort: "กรุณาเลือกการกำหนดค่าระดับการใช้เหตุผล",
        publish: "เผยแพร่",
        success: "สำเร็จ",
        restoreVersion: "กู้คืนเวอร์ชัน",
        latest: "ล่าสุด",
        logEvent: "บันทึกเหตุการณ์",
        log_menagement: "การจัดการบันทึก",
        dateRange : "ช่วงวันที่",
        Filters: "ตัวกรอง",
        search : "ค้นหา",
        warningFillConsentThEn: "กรุณากรอกข้อความยินยอม (TH) และ (EN)",
        warningFillConsentTh: "กรุณากรอกข้อความยินยอม (TH)",
        warningFillConsentEn: "กรุณากรอกข้อความยินยอม (EN)",
        PositiveQuestionSet: "ชุดคำถามเชิงบวก",
        Result: "ผลลัพธ์",
        ClearAll: "ล้างทั้งหมด",
        Download: "ดาวน์โหลด",
        DownloadReport: "ดาวน์โหลดรายงาน",
        AdvancedFilters: "ตัวกรองขั้นสูง",
        ClearFilters: "ล้างตัวกรอง",
        textValidateGroupName: "มีชื่อกลุ่มนี้อยู่แล้ว กรุณากรอกชื่อกลุ่มใหม่",
        _ShowFullText : "Show Full Text",
        _replaceDoc: "Replace Document",
        _AddMoreDoc: "Add Document",
        _ReplaceAllDoc: "Replace All Document",
        _DocTitle: "Document Management",
        syncUsers: "ผู้ใช้ซิงค์",
        template: "เทมเพลต",
        downloadTemplate: "ดาวน์โหลดเทมเพลต",
        downloadTemplateDescription: "ดาวน์โหลดไฟล์เทมเพลตสำหรับการนำเข้าข้อมูลผู้ใช้",
        import: "นำเข้า",
        importFile: "นำเข้าไฟล์ Excel (.xlsx) เพื่อเพิ่มข้อมูลผู้ใช้",
        addNewUser: "เพิ่มผู้ใช้ใหม่",
        syncUsersTooltip: "รีเฟรชรายชื่อผู้ใช้และสิทธิ์การเข้าถึงโดยดึงข้อมูลล่าสุดจากบริการยืนยันตัวตนภายนอก",
        totalResults: "ผลลัพธ์ทั้งหมด",
        editChatUser: "แก้ไขผู้ใช้แชท",
        editChatUserDescription: "แก้ไขข้อมูลบัญชีผู้ใช้สำหรับแชท",
        addChatUser: "เพิ่มผู้ใช้แชทใหม่",
        addChatUserDescription: "สร้างบัญชีผู้ใช้สำหรับแชทใหม่ด้วยข้อมูลที่จำเป็น",
        basicInfo: "ข้อมูลพื้นฐาน",
        usernameReadonly: "ชื่อผู้ใช้ (อ่านอย่างเดียว)",
        integrationSocial: "การเชื่อมต่อโซเชียล",
        socialUserID: "Social User ID",
        socialUserIDTooltip: "รหัสผู้ใช้ที่ถูกกำหนดโดยการเชื่อมต่อกับ Line",
        recipientIdFB: "Recipient ID (Facebook)",
        recipientIdFBTooltip: "รหัส Facebook ที่ใช้ระบุผู้รับในการสนทนา",
        recipientIdIG: "Recipient ID (Instagram)",
        recipientIdIGTooltip: "รหัส Instagram ที่ใช้แทนผู้ใช้หรือผู้รับที่เชื่อมต่อ",
        modelConfiguration: "การตั้งค่าโมเดล",
        modelGrouping: "การจัดกลุ่มโมเดล",
        modelGroupingTooltip: "เลือกกลุ่มที่กำหนดไว้ล่วงหน้าเพื่อจัดการหรือจัดระเบียบโมเดล AI ที่เกี่ยวข้อง",
        modelTooltip: "ชื่อเฉพาะของโมเดล AI ที่ใช้สำหรับการตั้งค่าในครั้งนี้",
        selectModels: "เลือกโมเดล",
        selectModelTooltip: "เลือกโมเดล AI ที่จะใช้ในการสร้างคำตอบสำหรับการสนทนา",
        selectModelGrouping: "เลือกการจัดกลุ่มโมเดล",
        modelShortcut: "ชอร์ตคัตโมเดล",
        modelShortcutTooltip: "กำหนดชอร์ตคัตเพื่อเลือกใช้งานโมเดลที่ใช้บ่อย",
        selectModelShortcut: "เลือกชอร์ตคัตโมเดล",
        accountSettings: "การตั้งค่าบัญชี",
        lockStatus: "สถานะล็อก",
        lockStatusTooltip: "แสดงสถานะว่าบัญชีผู้ใช้หรือการเข้าถึงแชทถูกล็อกหรือไม่",
        lockStatusLocked: "บัญชีจะถูกล็อกและไม่สามารถเข้าถึงระบบได้",
        lockStatusUnlocked: "บัญชีจะถูกปลดล็อกและสามารถเข้าถึงระบบได้",
        newLockStatusLocked: "บัญชีใหม่จะถูกล็อกและไม่สามารถเข้าถึงระบบได้",
        newLockStatusUnlocked: "บัญชีใหม่จะถูกปลดล็อกและสามารถเข้าถึงระบบได้",
        changePassword: "เปลี่ยนรหัสผ่าน",
        passwordSetup: "ตั้งรหัสผ่าน",
        passwordLength: "อย่างน้อย 8 ตัวอักษร",
        passwordLowercase: "ตัวอักษรพิมพ์เล็ก",
        passwordUppercase: "ตัวอักษรพิมพ์ใหญ่",
        passwordNumber: "ตัวเลข",
        passwordSpecialCharacter: "อักขระพิเศษ",
        passwordMatch: "รหัสผ่านตรงกัน",
        howToUseTemplates: "วิธีการใช้เทมเพลต:",
        templateStep1: "เลือกเทมเพลตที่เหมาะสมกับความต้องการของคุณ",
        templateStep2: "ดาวน์โหลดไฟล์เทมเพลต",
        templateStep3: "กรอกข้อมูลผู้ใช้ตามโครงสร้างที่กำหนดในเทมเพลต",
        templateStep4: "อัปโหลดไฟล์ที่กรอกเสร็จแล้วผ่านส่วนการนำเข้า",
        fileFormat: "รูปแบบไฟล์",
        CSVTooltip: "ดาวน์โหลดเทมเพลตทั่วไป - CSV",
        ExcelTooltip: "ดาวน์โหลดเทมเพลตทั่วไป - Excel",

        newPassword: "รหัสผ่านใหม่",
        newPasswordDescription: "สร้างรหัสผ่านใหม่ที่ปลอดภัยสำหรับบัญชีของคุณ",
        confirmNewPassword: "ยืนยันรหัสผ่านใหม่",

        securityTips: "เคล็ดลับความปลอดภัย:",
        securityStep1: "ใช้รหัสผ่านที่ไม่ซ้ำกับที่ใช้ในบริการอื่น",
        securityStep2: "พิจารณาใช้วลีรหัสผ่านที่มีตัวพิมพ์เล็ก พิมพ์ใหญ่ ตัวเลข และสัญลักษณ์",
        securityStep3: "หลีกเลี่ยงข้อมูลส่วนตัว เช่น ชื่อ วันเกิด หรือคำทั่วไป",
        securityStep4: "เปลี่ยนรหัสผ่านเป็นประจำเพื่อความปลอดภัยที่ดียิ่งขึ้น",

        deleteConfirm: "ยืนยันการลบ",
        deleteConfirmDescription: "คุณต้องการยืนยันการลบผู้ใช้คนนี้หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้",

    },
    en: {
        textValidateGroupName: "This group name already exists, please enter a new group name",
        ClearFilters : "Clear Filters",
        AdvancedFilters: "Advanced Filters",
        Download: "Download",
        DownloadReport: "Download Report",
        ClearAll: "Clear All",
        Result: "Result",
        PositiveQuestionSet: "Positive Question Set",
        search  : "Search",
        UserQuery : "User Query", 
        OrgVectorSearch: "Original Vector Search", 
        ModVectorSearch: "Translated Vector Search (Eng.)", 
        Company : "Company", 
        StreamUploadPrivateMemory:"Upload",
        StreamFileNamePrivateMemory:"Document Name",
        StreamPrivateMemory:"VECTOR",
        StreamPrivateMemoryAdd:"ADD",
        StreamPrivateMemoryEdit:"EDIT",
        StreamPopupFileHeader: "Upload Audio Files",
        StreamPopupVoiceHeader: "Voice Dictation",

        StreamPopuplang: "Language",
        StreamPopupRecord: "Start Dictation",
        FullStream: "Full Stream",
        Stream: "Chat Playground",
        no: "No.",
        date: "Date",
        description: "Description",
        usermanagement: "Portal User Management",
        userChatManagement: "Chat User Management",
        user: "User",
        _CompanyCode: "Company Code",
        username: "Username",
        email: "Email",
        search: "Search",
        warningFillConsentThEn: "Please fill Consent(TH) and Consent(EN) Message",
        warningFillConsentTh: "Please fill Consent(TH) Message",
        warningFillConsentEn: "Please fill Consent(EN) Message",
        
        UploadImageEx: "Example",
        IconPreview: "Icon Preview",
        UploadImage: "Icon",
        add: "Add",
        addProduct: "Add Product",
        addIntentSession: "Add Intent Session",
        New: "New",
        manage: "Manage",
        phonenumber: "Phone Number",
        employeename: "Employee Name",
        usertype: "User Type",
        edit: "Edit",
        delete: "Delete",
        deleteAll: "Delete All",
        deleteSelected: "Delete Selected",
        users: "Users",
        usergroup: "User Group",
        permissionmanagement: "Permission Management",
        menumanagement: "Menu Management",
        managementModelQuick : "Management : Quick Model",
        managementGPTModel: "Model Creator",
        // managementGPTModelDetail: "Management : LLMs Model Detail",
        managementGPTModelNode: "Management : GPT Model Internal",
        managementModelAndVector: "Management Model & Vector DB",
        ValidationGenerateUpload: "Validation generate : Upload",
        calendar: "Calendar",
        log: "Log",
        setting: "Setting",
        groupname: "Group Name",
        adduseringroup: "Add user in group",
        permissionname: "Permission Name",
        save: "Save",
        close: "Close",
        update: "Update",
        firstname: "First Name",
        lastname: "Last Name",
        indicatesrequiredfield: "Indicates required field",
        userprofile: "User Profile",
        logout: "Log Out",
        password: "Password",
        confirmpassword: "Confirm Password",
        checklengthcharacters: "Length of a least 8 letter",
        checklowercaseletter: "At least 1 lowercase letter",
        checkuppercaseletter: "At least 1 uppercase letter",
        checknumber: "Numbers(0-9)",
        checkspecialcharacter: "At least 1 special character",
        checkpasswordmatch: "Confirm password not match",
        rememberme: "Remember Me",
        forgotpassword: "Forgot Password?",
        login: "Login",
        successMessage: "Logged In Successfully",
        menuname: "Menu Name",
        number: "No",
        addgroupinmenu: "Add group in menu",
        addGPTModel: "Create GPTModel",
        updateGPTModel: "Update GPTModel",
        addGPTModelNode: "Create GPTModelNode",
        updateGPTModelNode: "Update GPTModelNode",
        uploadCSV: "Upload CSV",
        uploadNegativeQuestionSet: "Upload Negative Question Set",
        upload: "Upload",
        downloadTemplate: "Download template",
        addModelAndVector: "Add Model and Vector DB",
        type: "Type",
        role: "Role",
        setup_title: "Platform Integration",
        general_title: "Core Configurations",
        chatLogs_title: "Chat Logs",
        setup_search_name: "Name",
        setup_table_no: "ID",
        setup_table_key: "Name",
        setup_table_value: "Value",
        setup_btn_apply: "Apply",
        dashboard: "Dashboard",
        dashboardScore: "Dashboard score",
        question: "Question",
        answer: "Answer",
        score: "Score",
        Validation: "Validation",
        GenerateTestQuestions_title: "Question Generator",
        NegativeDataset_title: "Negative Question Sets",
        ExecuteTestRuns_title: "Execute Test Runs",
        DatabaseIntegration_title: "Database Integration",
        FileManagement_title: "File Management",
        Documents_title: "Documents",
        validationScore: "Validation score",
        calculateScores: "Calculate Scores",
        averageScore: "Average score",
        totalUser: "Total Users",
        month: "month",
        LastDayTotalUserUsage: "Last day total user usage",
        WithinThis30daysagoToTotalUsers: "Users within the last 30 days/Total Users",
        UserWithinThisDay: "Users within",
        DaysToTotalUsers: "days/Total Users",
        UpdatedIn: "Within the last day",
        UsageOverview: "Usage Overview",
        TokensUsedMonth: "Token Usage",
        Usage: "Usage",
        TokensUsed: "Total Tokens Used",
        TotalTokenIn: "Total Token In",
        TotalTokenOut: "Total Token Out",
        TotalPriceForTokenIn: "Total Price for Token In",
        TotalPriceForTokenOut: "Total Price for Token Out",
        TokensUsedTokensChat: "Total Tokens Used in Chat",
        DetailTokensUsedTokensChat: "Token Usage in Chat",
        DetailImageGenChat: "Image Generation Usage in Chat",
        ImageGenTotalInChat: "Total generated image in chat",
        ImageGenTotal: "Total image generated",
        TotalGeneratedImage: "Total Generated Image",
        ImageGenTotalPrice: "Total generated image price",
        TotalGeneratedImagePrice: "Total Generated Image Price",
        ImageGenTotalPriceInChat: "Total generated image price in chat",
        DallE3GeneratedImagesPriceInChat: "Dall-E 3 Generated Images Price in Chat",
        GeneratedImagesPriceInChat: "Generated Images Price in Chat",
        TokensUsedPromptTokensChat: "Total Prompt Tokens Used in Chat",
        GPT4oPromptTokens: "Prompt Tokens",
        ChatPromptTokens: "Chat Prompt Tokens",
        TokensUsedCompletionTokensChat: "Total Completion Tokens Used in Chat",
        GPT4oUsageTokens: "Usage Completion Tokens",
        ChatCompletionTokens: "Chat Completion Tokens",
        TokensUsedEmbedding: "Total Embedding Tokens",
        NumberUsers: "Total Users",
        TotalModels: "Total Models",
        WithinThisMonth: "Within this month",
        UserUsage: "User usage",
        TotalUsagePerMonth: "Total usage per month",
        NumberPeople: "Number of people",
        NumberData: "Number of data",
        People: "User",
        NumberQuestions: "Number of questions",
        gpt_model_management_replace: "Replace",
        gpt_model_management_version_history: "Version history",
        gpt_model_management_version_history_detail: "Version History Detail",
        gpt_model_management_export_file_config: "Export file",
        importVectorTitle: "Do you want to import a Vector?",
        importPrivate_MemoryTitle: "Do you want to import a Vector?",
        doctype : "DocType",
        vectortype : "Vector Type",
        process_type: "Process Type",
        yes: 'Yes',
        cancel: 'Cancel',
        confirm: 'Confirm',
        confirmDeletion: 'Delete Confirmation',
        confirmDeletion2: 'Do you want to confirm this deletion?',
        confirmDeletionGroup: 'Do you want to confirm deletion of this group?',
        // confirmDeletionModel: 'Do you want to confirm deletion of this model?',
        confirmDeletionModelPart1: 'Are you sure you want to delete model', // Added part 1
        confirmDeletionModelPart2: '', // Added part 2 (empty for English structure)
        confirmDeletionMessage: 'Do you want to confirm deletion of this message?',
        confirmDeletionModelGroup: 'Do you want to confirm deletion of this model group?',
        confirmDeletionModelShortcut: 'Do you want to confirm deletion of this model shortcut?',
        confirmDeletionSetting: 'Do you want to confirm deletion of this setting?',
        confirmDeletionVectorName: 'Do you want to confirm deletion of this vector name?',
        confirmDeletionVector: 'Do you want to confirm deletion of this vector?',
        confirmDeletionDocument: 'Do you want to confirm deletion of this document?',
        confirmDeletionDocumentName: 'Do you want to confirm deletion of this document name?',
        confirmDeletionTableName: 'Do you want to confirm deletion of this table name? This action cannot be undone.',
        confirmDeletionIntentGroup: 'Do you want to confirm deletion of this intent group?',
        confirmDeletionIntentSession: 'Do you want to confirm deletion of this intent session?',
        confirmDeletionUser: 'Do you want to confirm deletion of this user?',
        confirmDeletionFile: 'Do you want to confirm deletion of this file?',
        confirmDeletionAllFile: 'Do you want to confirm deletion of this all file?',
        confirmDeletionQuestion: 'Do you want to confirm deletion of this question?',
        confirmDeletionAllQuestion: 'Do you want to confirm deletion of all these questions?',
        confirmDeletionPrompt: 'Do you want to confirm deletion of this Prompt?',
        confirmOn: 'Confirm opening',
        confirmOff: 'Confirm closing',
        confirmOnVectorName: 'Do you want to confirm the opening of this vector?',
        confirmOffVectorName: 'Do you want to confirm the closure of this vector?',
        confirmDeleteConfirmation: 'Delete confirmation',
        vectorReprocess: "Do you want to Reprocess?",
        conditionScore0: '0 = the answer from GPT is not related to question.',
        conditionScore1: '1 = the answer from GPT is related to question around 50% - 80%.',
        conditionScore2: '2 = the answer from GPT is most relevant to the question and the answers that GPT cannot answer also.',
        general: 'General',
        social: 'Social',
        groupModel: 'Model Grouping',
        QuickModel: 'Model Shortcut',
        groupModelName: 'Model Group Name',
        groupIntentName: 'Name group Intent', 
        modelQuickGroupName: 'Name quick model',
        modelID: 'Model ID',
        model: 'Model',
        modelName: 'Model Name',
        modeldata: 'LLMs Management',
        editnewmodel: 'Edit New Model',
        deletemodeldata: 'Delete Model data',
        areyousuretodeletethisdata: 'Are you sure to delete this data?',
        addnewmodel: 'Add New Model',
        loadingpleasewait: 'Loading Please Wait...',
        pleasefillininformation: 'Please fill in information',
        superAdmin: 'Super admin',
        oneSuperAdmin: 'There must be at least one SuperAdmin role.',
        notAuthoritySuperAdmin: 'You do not have the authority to delete the SuperAdmin role.',
        admin: 'Admin',
        generalUsers: 'User',
        totalNumber: 'Total Number',
        groupReplaceText:'Text Replacement',
        replaceText:'ReplaceText',
        specificText : 'SpecificText',
        warning: 'Warning',
        warningSpecialCharacters: 'String contains special characters! Please remove them.',
        warningFillAll: 'Please fill in the complete information.',
        warningFillIntentGroupName: 'Please fill Intent Group Name',
        warningModelName: 'Please enter the Model name',
        warningProvider: 'Please select a Provider',
        warningModel: 'Please select a Model',
        warningPublish: 'Please select Draft or Publish',
        warningTemperature: 'Please enter a Temperature value between 0 - 1 (2 decimal)',
        warningChainMassage: 'Please enter a Sequence or Duration(s) for Enable Multi-Turn Input.',
        warningTopP: 'Please enter a topP value between 0 - 1 (2 decimal)',
        warningVectordbName: 'Please select a Vector DB name (more than one can be selected)',
        warningTopVDB: 'Please enter a Top VDB value starting from 1',
        warningAPIVersion: 'Please add API Version in Master Data',
        warningWaitProcess: 'Please wait for the previous process to finish working first',
        warningFillCustomMaxCharacter: 'Please fill in the Custom Max Character',
        warnningStartdateEnddate: 'Please fill in the StartDate and EndDate.',
        warningDuplicateDomain: 'The domain is already in use.',
        warningEnableTime: 'Time Zone is required. Since you have enabled time, please select a time zone for accurate responses.',
        warningEmailConfig: 'Please fill in the Mail Config complete information.',

        errorUploadImage: 'Unable to upload image, please try again.',
        importReplaceTextTitle: "Do you want to import a Replace Text?",
        importIntentText: "Do you want to import a Intent Text?",
        totalUsedChatExpense: "Total used chat expense",
        totalExpense: "Total price",
        totalPriceForEmbedding: "Total price for Embedding",
        priceForAllChatUsage: "Total price for chat usage",
        totalPriceOfPromptChat: "Total price of Prompt Chat",
        totalPriceOfCompletionChat: "Total price of Completion Chat",
        totalPriceOfUsageChat: "Total Price of Usage Chat",
        totalPriceOfPromptGPT3: "Total price of Prompt GPT-3-Turbo",
        totalPriceOfPromptGPT316k: "Total price of Prompt GPT-3-Turbo-16k",
        totalPriceOfPromptGPT4: "Total price of Prompt GPT-4",
        totalPriceOfPromptGPTOTHER: "Total price of Prompt Other",
        totalPriceOfCompletionChatGPT3: "Total price of Completion Chat GPT-3-Turbo",
        totalPriceOfCompletionChatGPT316k: "Total price of Completion Chat GPT-3-Turbo-16k",
        totalPriceOfCompletionChatGPT4: "Total price of Completion Chat GPT-4",
        totalPriceOfCompletionChatGPTOTHER: "Total price of Completion Chat Other",
        baht: "THB",
        TokensUsedPromptGPT3TokensChat: "Total Prompt Tokens GPT-3-Turbo used in Chat",
        TokensUsedPromptGPT316kTokensChat: "Total Prompt Tokens GPT-3-Turbo-16k used in Chat",
        TokensUsedPromptGPT4TokensChat: "Total Prompt Tokens GPT-4 used in Chat",
        TokensUsedCompletionGPT3TokensChat: "Total Completion Tokens GPT-3-Turbo  used in Chat",
        TokensUsedCompletionGPT316kTokensChat: "Total Completion Tokens GPT-3-Turbo-16k  used in Chat",
        TokensUsedCompletionGPT4TokensChat: "Total Completion Tokens GPT-4 used in Chat",
        promptPrice:"Prompt price",
        completionPrice:"Completion price",
        T30dayago: "Within the last 30 days",
        WithinThis30daysago: "Within the last 30 days",
        WithinThisDaysAgo: "Within",
        LastDays: "Last",
        Day: "day",
        ReportQuestion: "Question Trends",
        ReportUser: "Top Users",
        ReportFeedback: "Report Feedback",
        Questions: "Questions",
        Answers: "Answers",
        LikeDislike: "Like / Dislike",
        Comments: "Comments",
        PromptTemplate: "Prompt Template",
        Active: "Active",
        Inactive: "Inactive",
        ReportTotalQuestionByUser: "Total Usage Insights",
        SettingExternalConnector: "External Connector",
        ModelDisplay: "Model Display",
        Provider: "Provider",
        releases: "Release notes",
        vector_management_duplicate: "Duplicate",
        vector_management_replace: "Replace",
        vector_duplicate : "Duplicate Document",
        importUserTitle: "Do you want to import a User?",
        system: "System",
        internal: "Internal",
        external: "External",
        testConnection: "Test Connection",
        allcolumn: "Get All Column",
        connectionString: "Connection string",
        view: "view",
        view_detail: "View detail",
        dataIntegrationName: "Data Integration Name",
        SocialUserID: "Line UserID",
        RecipientId: "Facebook UserID",
        RecipientId_Instagram: "Instagram User ID",
        ConfirmDataAddition: "Confirm data addition",
        TranslateEnglish: "Translate english",
        DataSearchVector: "Data search vector",
        selectToDeleteFile: "Select to delete file",
        
        _InfoModelDisplay: "The Model Display information will show the Model Display number when it is Published or Drafted.",
        _InfoModelName: "Model name.",
        _InfoProvider: "Select a service provider.",
        _InfoModel: "Model from the service provider.",
        _InfoExtension: "Extension of the model",
        _InfoDescriptiion: "Additional description",
        _InfoGender: "The gender of Chatbot",
        _InfoVersion: "The version currently in use",
        _InfoStream: "In the case of selecting Stream, it will be a situation where the Chat Framework will display responses one character at a time.",
        _InfoByPass: "In the case of selecting Bypass, it will be a situation where the Chat Framework is allowed to respond with information outside of the specified Prompt or Vector data, and can search for information from public knowledge to answer.",
        _InfoFeedback: "In the case of selecting Feedback, it will be a situation where the Chat Framework is allowed to respond with information outside of the specified Prompt or Vector data, and can search for information from public knowledge to answer.",
        _InfoEnableTime: "If enabled, the system will include the current date and time in the prompt, allowing the bot to understand and respond based on real-time information.",
        _InfoImageUpload: "In the case of selecting “Upload image”, it allows the Chat Framework to use the image upload function for questioning.",
        _InfoVectorDBName: "The vector that has been created can be modified in the Documents page.",
        _InfoGroupReplaceText: "Replace specific words before translation to ensure data accuracy.",
        _InfoTopVDB: "The maximum sequence of probabilities",
        _InfoCosine: "The maximum number of probabilities",
        _InfoSequence: "The number of conversation sequences to be combined for use in the latest search and answer questions",
        _InfoTimeSeconds: "Link the questions within a specified time range (seconds)",
        _InfoMemory: "Memory",
        _InfoMultiTurnInput: "Enable Multi-Turn Input",
        _InfoTurn: "The number of turn data can be stored.",
        _InfoMinute: "The time that can remember the data.",
        _InfoShortMemory: "The number of characters for storing data.",
        _InfoLongtermMemory: "Long-term data storage (storing data in chunk format).",
        _InfoTemperature: "Controls randomness. Lowering the temperature means that the model will produce more repetitive and deterministic responses. Increasing the temperature will result in more unexpected or creative responses. Try adjusting temperature or Top P but not both.",
        _InfoTopP: "Similar to temperature, this controls randomness but uses a different method. Lowering Top P will narrow the model’s token selection to likelier tokens. Increasing Top P will let the model choose from tokens with both high and low likelihood. Try adjusting temperature or Top P but not both.",
        _InfoFrequencyPenalty: "Reduce the chance of repeating a token proportionally based on how often it has appeared in the text so far. This decreases the likelihood of repeating the exact same text in a response.",
        _InfoPresencePenalty: "Reduce the chance of repeating any token that has appeared in the text at all so far. This increases the likelihood of introducing new topics in a response.",
        _InfoMaxToken: "Maximum number of Tokens",
        _InfoStop: "Make the model end its response at a desired point. The model response will end before the specified sequence, so it won't contain the stop sequence text. For ChatGPT, using <|im_end|> ensures that the model response doesn't generate a follow-up user query. You can include as many as four stop sequences.",
        _InfoDataIntegration: "Data from Data Integration",
        _InfoSQLExtractStatement : "The model used to create SQL Statement",
        _InfoPromt: "Give the model instructions about how it should behave and any context it should reference when generating a response. You can describe the assistant’s personality, tell it what it should and shouldn’t answer, and tell it how to format responses. There’s no token limit for this section, but it will be included with every API call, so it counts against the overall token limit.",
        _InfoAdditionalPromt: "Can select a prompt template to replace the current prompt.",
        _InfoVectorDatabaseName: "The name is Vector.",
        _InfoProcess_type: "Choose the type of operation.",
        _InfoCustomMaxCharacter: "Custom Max Character",
        _InfoDetectLanguage: "Check the language.",
        _InfoDoctype: "The type of document you want to upload.",
        _InfoVectortype: "Check the structure type of the uploaded document. You can check the document type at the Template.",
        _InfofillterModelType: "Types of data segmentation",
        _InfoDataIntegrationName: "Data integration name",
        _InfoConnectionString: "Connect to SQL Server Connection string",
        _InfoSchema: "Schema name",
        _InfoTable: "Table name",
        _InfoFuzzy: "Compare data in the table for use in correcting errors.",
        _InfoFuzzyWithBot: "FuzzyWithBot : Compare data in the table for use in correcting errors By Bot.",
        _Personal_Info: "This column data will be checked for user access.",
        _InfoAllCloumns: "Get All Columns in Table.",
        _InfoAddColumn: "Add only the desired column (not necessary to use every column in the table).",
        _InfoReplaceGroup: "Please enter the group name.",
        _InfoNumberOfQuestions: "Number of questions to be generated",
        _InfoNumberOfQuestionsTone: "Set the number to create questions for each Tone.",
        _InfoTypeOptions: "Token usage = For checking the number of tokens used, Raw log = All logs, Memory Debugger = Memory data stored in each question and answer session.",
        _InfoStartDate: "Start date",
        _InfoEndDate: "End date",
        _InfoValidationNegariveName: "Validation Negative name",
        _InfoValidationName: "Validation name",
        _InfoQuestionPositiveName: "Question Positive name",
        _InfoQuestionNegativeName: "Question Negative name",
        _InfoSelectModel: "Select Model",

        _InfoBoxFirm: "Firm",
        _InfoBoxConfident: "Confident",
        _InfoBoxPoetic: "Poetic",
        _InfoBoxNarrative: "Narrative",
        _InfoBoxProfessional: "Professional",
        _InfoBoxDescriptive: "Descriptive",
        _InfoBoxHumorous: "Humorous",
        _InfoBoxAcademic: "Academic",
        _InfoBoxPersausive: "Persausive",
        _InfoBoxFormat: "Format",
        _InfoBoxInformal: "Informal",
        _InfoBoxFriendly: "Friendly",

        _InfoSelectGroupModel: "Select the Group model if you want to edit a Model that is within a group. You can make edits on the Group model page.",
        _InfoSelectQuickModel: "Choose Quick model if you want to edit the Model within the group. You can edit it on the Quick model page.",
        _InfoCurrentPrompPrice: "The price for asking questions per 1,000 tokens",
        _InfoCurrentComppletionPrice: "The price for answering questions per 1,000 tokens",
        _InfoVersionOfModel: "Version of the model",
        _InfoPromptTemplateName: "Name of the Prompt template",
        _InfoStatusTemplate: "The status of using the Template. You can activate up to 10 Templates.",
        _InfoPriority: "Priority",
        _InfoGroupModelName: "Name of the model that is grouped",
        _InfoGroupPromptTemplate: "Select Group Prompt template.",
        _InfoAllModel: "All model",
        _InfoModelinGroup: "The selected model will be grouped together.",
        _InfoTimeDelay: "Time Delay(millisec)",
        _InfoLimitedCharacter: "Limited Character.",
        _InfoHostName: "Host name",
        _InfoEmailHost: "Email host",
        _InfoSetupLinkMS: "Link for use on MS Teams (iFrame).",
        _InfoModelQuickGroupName: "Models under the Group model.",
        _InfoGroupName: "Models Group Name.",
        _InfoMSTeamsName: "Name used for MS Teams.",
        _InfoMonitorLINEUserid: "UserID of Line used for Monitor.",
        _InfoLINEName: "Line name",
        _InfoTypingSpeed: "Typing Speed(millisec)",
        _InfoMaximumChatInput: "Maximum chat input text area(character)",
        _InfoDomainNameForSnippet: "Domain name used for Snippet.",
        _InfoFacebookName: "Name used for Facebook.",
        _InfoAPI_Version: "API Version for Facebook Messenger API.",
        _InfoPageId: "Page ID for Facebook Page.",
        _InfoMaximumFileUpload: "Set the file upload limit (KB)",
        _UseUploadFile: "Use file upload",
        _InfoScore: "Score is the level of importance, ranked from least to most. For example, if there is more than one matching intent, the intent with the lowest score will be selected.",
        _InfoForUploadDateTimeDataType: "If you select the data type as datetime, put it as in the format yyyy/MM/dd HH:mm:ss only, e.g., 2024/12/31 12:30:00.",
        _InfoForDeleteAllFile: "Delete all files",
        _InfoInstagramName: "Name used for Instagram.",

        _InfoNotiOn: "Notification sound turned on",
        _InfoNotiOff: "Notification sound has been turned off.",

        loginMicrosoft: "Sign in with Microsoft",
        sync: "Sync",
        _SSOWarning: "Single Sign-On is not yet enabled. Please go to the Setup menu to enable it.",
        PlayGround: "Dual Chat Playground",
        _columnDataIntegration : "Column",
        _typeDataIntegration : "Data Type",
        _duplicateColumn : "Duplicate Column",
        _incorrectColumn : "Incorrect Column",
        _ConfirmDataUpdate: "Confirm data update",

        _ShowAllText : "Show All Text",
        _ShowAllTextOn : "ON",
        _ShowAllTextOff : "OFF",
        _ShowPromptTemplate: "Show Prompt Template",
        _ShowAll: "Show All",
       
        //Navbar Name
        _Dashboard : "Dashboard",
        _ModelCreator : "Model Creator",
        _KnowledgeManagement : "Knowledge Management",
        _Documents : "Documents",
        _DocumentList : "Document List",
        _DatabaseIntegration: "Database Integration",
        _OptimizationTechniques : "Optimization Techniques",
        _TextReplacement : "Text Replacement",
        _ModelTesting : "Model Testing",
        _GenerateTestQuestions : "Question Generator",
        _NegativeQuestionSet : "Negative Question Set",
        _UploadNegativeQuestionSet: "Upload Negative Question Set",
        _EditNegativeQuestionSet: "Edit Negative Question Set",
        _ExecuteTestRuns : "Execute Test Runs", 
        _UserManagement : "User Management",
        _PortalUserManagement : "Portal User", 
        _ChatUserManagement : "Chat User Management",
        _ChatUser: "Chat User",
        _ChatManagement : "Chat Management",
        _Setting : "Setting",
        _CoreConfigurations : "Core Configurations", 
        _PlatformIntegration : "Platform Integration",
        _ModelGrouping : "Model Grouping", 
        _ExternalConnector : "External Connector",
        _ModelShortcut : "Model Shortcut",
        _LLMsManagement : "LLMs Management",
        _PromptTemplate : "Prompt Template Group List ",
        _Reports : "Reports",
        _QuestionTrends : "Question Trends",
        _TopUsers : "Top Users",  
        _TotalUsageInsights : "Total Usage Insights",
        _ChatLogs : "Chat Logs",
        _ChatPlayground : "Chat Playground", 
        _DualChatPlayground : "Dual Chat Playground", 
        _ChatService : "Chat Service", 
        _DocumentManagement: "Document Management",
        _Product: "Product",
        _ProductDetail: "Product Detail",

        _EnableTime: "Enable date and time in prompt",
        serviceTheme: "Theme Service",
        consentConfig: "Consent Config",
        IntentGroup: "Intent Group",
        IntentSession: "Intent Session",
        TokenSummation: "Token summation",
        Intent: "Intent",
        _uploadCSVVector: "Upload Vector",
        configTheme: "Config Theme",
        loginAuthentik: "Sign in with Authentik",
        _GroupUserManagement: "Group User Management",
        _UserGroup: "User Group",
        _UserGroupManagement: "User Group Management",
        addUserGroup: "Add User Group",
        groupPromptName: "Group Prompt Template",
        modelGroup: "Model Group",
        _UserGroupDetail: "User Group Detail",
        _SetupUserGroup: "Setup User Group",
        action: "Action",
        groupObjectID: "Group ObjectID",
        fullName: "Full name",
        loginLine: "Sign in with Line",
        statusSync: "Status Sync",
        _BlacklistChatUserManagement: "Blacklist Chat User Management",
        _BlacklistChatUser: "Blacklist Chat User",
        _username: "User name",
        _userid: "User ID",
        _date: "Date",
        _FileManagement: "File Management",
        confirmToSetDefault: "Confirm To Set Default",
        infoconfirmToSetDefault: "Do you want to confirm To set the default?",
        headerLogo: "Header Logo",
        background: "Background",
        _LockStatus: "Lock Status",
        _Locked: "Locked",
        _Unlocked: "Unlocked",
        _Connection_failed: "Connection failed.",
        _Please_check_internet: "Please check your internet.",
        _Operator: "Operator",
        _Please_Question: "Please specify your question.",
        _HumanAnswer: "Human Answer",
        _Reprocess: "Do you want to Reprocess?",
        "Upload Sound To Document": "Upload Sound To Document",
        "Positive Question set": "Positive Question set",
        "Model Quick Reply": "Model Quick Reply",
        Logs: "Logs",
        "Report Feedback": "Report Feedback",
        ShortcutCommands: "Shortcut Commands",
        shortcutMenu: "Shortcut Menu",
        usermanual: "User Manual",
        releasesnotes: "Release Notes",
        alreadyPublishedModel: "This model has already been published.",
        gotIt: "Got it",
        "Event Log": "Event Log",
        _ReasoningEffort: "Apply the reasoning effort level configuration",
        _EndPointURL: "End Point URL",
        _WarningJSONFormat: "Enter the data in JSON format.",
        _API_Key: "API Key",
        warningReasoningEffort: "Please select the reasoning effort level configuration.",
        publish: "Publish",
        restoreVersion: "Restore version",
        success: "Success",
        latest: "Latest",
        logEvent: "Log Event",
        log_menagement: "Log Management",
        dateRange : "Date Range",
        Filters : "Filters",
        _ShowFullText : "Show Full Text",
        _replaceDoc: "Replace Document",
        _AddMoreDoc: "Add Document",
        _ReplaceAllDoc: "Replace All Document",
        _DocTitle: "Document Management",
        syncUsers: "Sync Users",
        template: "Template",
        downloadTemplate: "Download Template",
        downloadTemplateDescription: "Download template files for user import",
        import: "Import",
        importFile: "Import an Excel (.xlsx) file to import user data.",
        addNewUser: "Add New User",
        syncUsersTooltip: "Manually refresh the user list and permission by pulling the latest data from the connected external authentication service.",
        totalResults: "Total results",
        editChatUser: "Edit Chat User",
        editChatUserDescription: "Edit user chat account information",
        addChatUser: "Add New Chat User",
        addChatUserDescription: "Create a new user chat account with required information",
        basicInfo: "Basic Information",
        usernameReadonly: "Username (Read Only)",
        integrationSocial: "Integration Social",
        socialUserID: "Social User ID",
        socialUserIDTooltip: "Identifier assigned to a user from Line integration.",
        recipientIdFB: "Recipient ID (Facebook)",
        recipientIdFBTooltip: "Facebook ID used to identify the recipient in chat interactions.",
        recipientIdIG: "Recipient ID (Instagram)",
        recipientIdIGTooltip: "Instagram ID representing the connected user or recipient.",
        modelConfiguration: "Model Configuration",
        modelGrouping: "Model Grouping",
        modelGroupingTooltip: "Choose a predefined group to organize or manage related AI models",
        modelTooltip: "The unique name of the AI model designated for this particular configuration setup.",
        selectModels: "Select Models",
        selectModelTooltip: "Choose the AI model that will be used for generating responses in the chat.",
        selectModelGrouping: "Select Model Grouping",
        modelShortcut: "Model Shortcut",
        modelShortcutTooltip: "Assign between frequently used models through shortcut.",
        selectModelShortcut: "Select Model Shortcut",
        accountSettings: "Account Settings",
        lockStatus: "Lock Status",
        lockStatusTooltip: "Indicates whether the user account or chat access is locked or unlocked.",
        lockStatusLocked: "Account will be locked and cannot access the system",
        lockStatusUnlocked: "Account will be unlocked and can access the system",
        newLockStatusLocked: "New account will be locked and cannot access the system",
        newLockStatusUnlocked: "New account will be unlocked and can access the system",
        changePassword: "Change Password",
        passwordSetup: "Password Setup",
        passwordLength: "At least 8 characters",
        passwordLowercase: "Lowercase letter",
        passwordUppercase: "Uppercase letter",
        passwordNumber: "Number",
        passwordSpecialCharacter: "Special character",
        passwordMatch: "Passwords match",
        howToUseTemplates: "How to use templates:",
        templateStep1: "Select the appropriate template format for your needs",
        templateStep2: "Download the template file",
        templateStep3: "Fill in your user data following the template structure",
        templateStep4: "Upload the completed file using the import section",
        fileFormat: "File Format",
        CSVTooltip: "Download General - CSV Template",
        ExcelTooltip: "Download General - Excel Template",
        newPassword: "New Password",
        newPasswordDescription: "Create a new secure password for your account",
        confirmNewPassword: "Confirm New Password",
        securityTips: "Security Tips:",
        securityStep1: "Use a unique password that you don't use elsewhere",
        securityStep2: "Consider using a passphrase with mixed case, numbers, and symbols",
        securityStep3: "Avoid personal information like names, birthdays, or common words",
        securityStep4: "Change your password regularly for better security",
        deleteConfirm: "Delete Confirmation",
        deleteConfirmDescription: "Do you want to confirm delete of this user? This action cannot be undone.",
    }
}
const i18n = createI18n({
    legacy: true, // สำหรับใช้กับ Vue 2 API ใน Vue 3
    locale: localStorage.getItem("locale") ?? "en", // set locale
    fallbackLocale: "th", // set fallback locale
    messages // set locale messages
});

const i18nPlugin = {
    install(app) {
        app.config.globalProperties.$filters = {
            myLocale(value) {
                return i18n.global.t(value);
            }
        };
    }
};

export default i18n;
export { i18nPlugin };